"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    feltErDropdown: function() {
        return feltErDropdown;
    },
    feltErRadio: function() {
        return feltErRadio;
    },
    feltErAvkrysningsboks: function() {
        return feltErAvkrysningsboks;
    },
    SLETTET_VERDI: function() {
        return SLETTET_VERDI;
    },
    foelgerBetingelse: function() {
        return foelgerBetingelse;
    },
    foelgerAlleBetingelser: function() {
        return foelgerAlleBetingelser;
    },
    feltSkalAktiveres: function() {
        return feltSkalAktiveres;
    },
    feltSkalDeaktiveres: function() {
        return feltSkalDeaktiveres;
    },
    feltSkalSkjules: function() {
        return feltSkalSkjules;
    },
    feltgruppeTekstSkalSkjules: function() {
        return feltgruppeTekstSkalSkjules;
    },
    feltSkalSkjulesIKort: function() {
        return feltSkalSkjulesIKort;
    },
    feltSkalSlettes: function() {
        return feltSkalSlettes;
    },
    feltHarBeholdVerdi: function() {
        return feltHarBeholdVerdi;
    },
    feltHarAktiverDeaktiverGitt: function() {
        return feltHarAktiverDeaktiverGitt;
    },
    feltHarReferanseTilAktiverDeaktiverGitt: function() {
        return feltHarReferanseTilAktiverDeaktiverGitt;
    },
    skjulFeltMedReferansekobling: function() {
        return skjulFeltMedReferansekobling;
    },
    finnDefaultVerdi: function() {
        return finnDefaultVerdi;
    },
    skalEkspandereFeltgruppe: function() {
        return skalEkspandereFeltgruppe;
    },
    erPresentasjonsfelt: function() {
        return erPresentasjonsfelt;
    }
});
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _has = /*#__PURE__*/ _interop_require_default(require("lodash/has"));
var _isBoolean = /*#__PURE__*/ _interop_require_default(require("lodash/isBoolean"));
var _isEmpty = /*#__PURE__*/ _interop_require_default(require("lodash/isEmpty"));
var _utils = require("../utils");
var _utils1 = require("../validering/utils");
var _flereReferanser = /*#__PURE__*/ _interop_require_wildcard(require("../transformering/transformerere/flereReferanser"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var feltErDropdown = function(felt) {
    return felt.opsjon && felt.opsjon.type === "dropdown";
};
var feltErRadio = function(felt) {
    return felt.opsjon && felt.opsjon.type === "radio";
};
var feltErAvkrysningsboks = function(felt) {
    return felt.opsjon && felt.opsjon.type === "avkrysningsboks";
};
var SLETTET_VERDI = "<<<--{(SLETT)}-->>>";
var BETINGELSER = [
    "aktiverGitt",
    "synligGitt",
    "deaktiverGitt",
    "skjulGitt"
];
var BETINGELSER_MULTIPLE = [
    "aktiverGittAlle",
    "deaktiverGittAlle",
    "synligGittAlle",
    "skjulGittAlle",
    "aktiverGittMinstEn",
    "deaktiverGittMinstEn",
    "synligGittMinstEn",
    "skjulGittMinstEn"
];
var verdiErTom = function(verdi) {
    return verdi === "" || verdi === null || verdi === undefined || verdi === SLETTET_VERDI;
};
var foelgerBetingelse = function(forekomstData, betingelse) {
    var visningsdata = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, kontroll = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], kodelister = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    if (betingelse.alle) {
        return foelgerAlleBetingelser(forekomstData, betingelse.alle, visningsdata, kontroll, kodelister);
    }
    if (betingelse.minstEn) {
        return foelgerMinstEnBetingelse(forekomstData, betingelse.minstEn, visningsdata, kontroll, kodelister);
    }
    var verdi = (0, _get.default)(forekomstData, betingelse.referanse);
    var harVerdi = !verdiErTom(verdi);
    switch(true){
        case (0, _has.default)(betingelse, "betingelseErAlltid"):
            {
                return betingelse.betingelseErAlltid;
            }
        case (0, _has.default)(betingelse, "harIkkeKontrollutslag"):
            {
                return !kontroll.some(function(param) {
                    var kontrollnavn = param.kontrollnavn;
                    return kontrollnavn === betingelse.harIkkeKontrollutslag;
                });
            }
        case (0, _has.default)(betingelse, "harKontrollutslag"):
            {
                if ((0, _isEmpty.default)(kontroll)) {
                    return false;
                }
                return kontroll.some(function(param) {
                    var kontrollnavn = param.kontrollnavn;
                    return kontrollnavn === betingelse.harKontrollutslag;
                });
            }
        case (0, _has.default)(betingelse, "harKorttype"):
            {
                if ((0, _isEmpty.default)(visningsdata)) {
                    return false;
                }
                var harKorttype = betingelse.harKorttype, restBetingelse = _object_without_properties(betingelse, [
                    "harKorttype"
                ]);
                var forekomster = (0, _get.default)(visningsdata, harKorttype, []);
                if (forekomster.length) {
                    if ((0, _isEmpty.default)(restBetingelse)) {
                        return true;
                    }
                    return forekomster.some(function(forekomst) {
                        return foelgerBetingelse(forekomst, restBetingelse, visningsdata, kontroll, kodelister);
                    });
                }
                return false;
            }
        case (0, _has.default)(betingelse, "harSubforekomsttype"):
            {
                var harSubforekomsttype = betingelse.harSubforekomsttype, restBetingelse1 = _object_without_properties(betingelse, [
                    "harSubforekomsttype"
                ]);
                var subforekomster = (0, _get.default)(forekomstData, harSubforekomsttype, []);
                if (subforekomster.length) {
                    if ((0, _isEmpty.default)(restBetingelse1)) {
                        return true;
                    }
                    return subforekomster.some(function(subforekomst) {
                        return foelgerBetingelse(subforekomst, restBetingelse1, visningsdata, kontroll, kodelister);
                    });
                }
                return false;
            }
        case (0, _has.default)(betingelse, "harVerdi"):
            {
                return harVerdi === betingelse.harVerdi;
            }
        case (0, _has.default)(betingelse, "mindreEnn"):
            {
                var verdiSomTall = Number(verdi);
                if ((0, _utils1.isNumber)(betingelse.mindreEnn)) {
                    return harVerdi && (0, _utils1.isNumber)(verdiSomTall) && verdiSomTall < betingelse.mindreEnn;
                }
                return harVerdi && verdi < betingelse.mindreEnn;
            }
        case (0, _has.default)(betingelse, "stoerreEnn"):
            {
                var verdiSomTall1 = Number(verdi);
                if ((0, _utils1.isNumber)(betingelse.stoerreEnn)) {
                    return harVerdi && (0, _utils1.isNumber)(verdiSomTall1) && verdiSomTall1 > betingelse.stoerreEnn;
                }
                return harVerdi && verdi > betingelse.stoerreEnn;
            }
        case (0, _has.default)(betingelse, "medVerdi"):
            {
                if (!harVerdi) {
                    // hvis en sjekkboks mangler verdi, er den lik false, se SH-5538
                    return betingelse.medVerdi === "" || betingelse.medVerdi === false || betingelse.medVerdi === "false";
                }
                return (0, _utils.erLikSomString)(verdi, betingelse.medVerdi);
            }
        case (0, _has.default)(betingelse, "ulikVerdi"):
            {
                // skal ikke brukes for sjekkboks, bruk da medVerdi
                return !(0, _utils.erLikSomString)(verdi, betingelse.ulikVerdi);
            }
        case (0, _has.default)(betingelse, "erEnAv"):
            {
                if (!harVerdi) {
                    return betingelse.erEnAv.includes("");
                }
                return betingelse.erEnAv.includes(verdi);
            }
        case (0, _has.default)(betingelse, "erIkkeEnAv"):
            {
                return !betingelse.erIkkeEnAv.includes(verdi);
            }
        case (0, _has.default)(betingelse, "minstEnHarVerdiFor"):
            {
                return harVerdi && verdi.some(function(forekomst) {
                    return (0, _has.default)(forekomst, betingelse.minstEnHarVerdiFor);
                });
            }
        case (0, _has.default)(betingelse, "minstEnHarIkkeVerdiFor"):
            {
                return harVerdi && verdi.some(function(forekomst) {
                    return !(0, _has.default)(forekomst, betingelse.minstEnHarIkkeVerdiFor);
                });
            }
        case (0, _has.default)(betingelse, "medVerdiIKodeliste"):
            {
                var _kodeliste_verdi;
                var kodelisteNavn = betingelse.medVerdiIKodeliste, kodetillegg = betingelse.kodetillegg;
                var kodeliste = kodelister[kodelisteNavn];
                return !!((_kodeliste_verdi = kodeliste[verdi]) === null || _kodeliste_verdi === void 0 ? void 0 : _kodeliste_verdi[kodetillegg]);
            }
        default:
            return false;
    }
};
var foelgerAlleBetingelser = function(data, betingelser, visningsdata, kontroll, kodelister) {
    return betingelser.every(function(betingelse) {
        if (betingelse.minstEn) {
            return foelgerMinstEnBetingelse(data, betingelse.minstEn, visningsdata, kontroll, kodelister);
        }
        return foelgerBetingelse(data, betingelse, visningsdata, kontroll, kodelister);
    });
};
var foelgerMinstEnBetingelse = function(data, betingelser, visningsdata, kontroll, kodelister) {
    return betingelser.some(function(betingelse) {
        if (betingelse.alle) {
            return foelgerAlleBetingelser(data, betingelse.alle, visningsdata, kontroll, kodelister);
        }
        return foelgerBetingelse(data, betingelse, visningsdata, kontroll, kodelister);
    });
};
var feltSkalAktiveres = function(felt, data, visningsdata, kontroll) {
    if (felt.aktiverGitt) {
        return foelgerBetingelse(data, felt.aktiverGitt, visningsdata, kontroll);
    }
    if (felt.aktiverGittAlle) {
        return foelgerAlleBetingelser(data, felt.aktiverGittAlle, visningsdata, kontroll);
    }
    if (felt.aktiverGittMinstEn) {
        return foelgerMinstEnBetingelse(data, felt.aktiverGittMinstEn, visningsdata, kontroll);
    }
    return undefined;
};
var feltSkalDeaktiveres = function(felt, data, visningsdata, kontroll) {
    if (felt.deaktiverGitt) {
        return foelgerBetingelse(data, felt.deaktiverGitt, visningsdata, kontroll);
    }
    if (felt.deaktiverGittAlle) {
        return foelgerAlleBetingelser(data, felt.deaktiverGittAlle, visningsdata, kontroll);
    }
    if (felt.deaktiverGittMinstEn) {
        return foelgerMinstEnBetingelse(data, felt.deaktiverGittMinstEn, visningsdata, kontroll);
    }
    if (felt.aktiverGitt || felt.aktiverGittAlle || felt.aktiverGittMinstEn) {
        return !feltSkalAktiveres(felt, data, visningsdata, kontroll);
    }
    return undefined;
};
var feltSkalSkjules = function(felt, data, visningsdata, kontroll) {
    if (felt.skjulGitt) {
        return foelgerBetingelse(data, felt.skjulGitt, visningsdata, kontroll);
    }
    if (felt.skjulGittAlle) {
        return foelgerAlleBetingelser(data, felt.skjulGittAlle, visningsdata, kontroll);
    }
    if (felt.skjulGittMinstEn) {
        return foelgerMinstEnBetingelse(data, felt.skjulGittMinstEn, visningsdata, kontroll);
    }
    if (felt.synligGitt || felt.synligGittAlle || felt.synligGittMinstEn) {
        return !feltSkalVaereSynlig(felt, data, visningsdata, kontroll);
    }
    return false;
};
var feltgruppeTekstSkalSkjules = function(felt, data) {
    if (felt.skjulFeltgruppeTekstGitt) {
        return foelgerBetingelse(data, felt.skjulFeltgruppeTekstGitt);
    }
    return false;
};
var feltSkalSkjulesIKort = function(felt, data) {
    // skjulIKort støtter kun bolsk verdi pr nå. Kan tenkes at den kan utvides til å støtte betingelser på sikt.
    if (felt.skjulIKort && typeof felt.skjulIKort === "boolean") {
        return felt.skjulIKort;
    }
    if (felt.visIKort) {
        return !foelgerBetingelse(data, felt.visIKort);
    }
    return false;
};
var feltSkalVaereSynlig = function(felt, data, visningsdata, kontroll) {
    if (felt.synligGitt) {
        return foelgerBetingelse(data, felt.synligGitt, visningsdata, kontroll);
    }
    if (felt.synligGittAlle) {
        return foelgerAlleBetingelser(data, felt.synligGittAlle, visningsdata, kontroll);
    }
    if (felt.synligGittMinstEn) {
        return foelgerMinstEnBetingelse(data, felt.synligGittMinstEn, visningsdata, kontroll);
    }
    return undefined;
};
var gyldigVerdiIOpsjon = function(felt, verdi, forekomstData, visningsdata, kontroll, kodelister) {
    var _felt_opsjon, _felt_transformer;
    if (!((_felt_opsjon = felt.opsjon) === null || _felt_opsjon === void 0 ? void 0 : _felt_opsjon.verdier) || verdiErTom(verdi) || ((_felt_transformer = felt.transformer) === null || _felt_transformer === void 0 ? void 0 : _felt_transformer.id) === "tilhoerendeEiendom") {
        return true;
    }
    var opsjoner = felt.opsjon.verdier;
    if (felt.opsjon.verdierGittBetingelse) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = felt.opsjon.verdierGittBetingelse[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var verdierGittBetingelse = _step.value;
                if (foelgerBetingelse(forekomstData, verdierGittBetingelse.betingelse, visningsdata, kontroll, kodelister)) {
                    opsjoner = verdierGittBetingelse.verdier;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (felt.opsjon.gruppering) {
        return opsjoner.map(function(param) {
            var tekniskNavn = param.tekniskNavn;
            return tekniskNavn;
        }).includes(verdi);
    }
    return opsjoner.includes((0, _utils.removeLeadingZeros)(verdi, felt));
};
var erBetingetBeregnetFelt = function(felt) {
    return felt && felt.betingetBeregnetFelt === true;
};
var feltSkalSlettes = function(felt, data, visningsdata, kontroll, kodelister) {
    var verdi = (0, _get.default)(data, felt.referanse);
    var harVerdi = !verdiErTom(verdi);
    var feltSkalDeaktiveresEllerSkjules = feltSkalDeaktiveres(felt, data, visningsdata, kontroll) || feltSkalSkjules(felt, data, visningsdata, kontroll);
    var feltSkalBeholdes = (feltHarBeholdVerdi(felt) || erBetingetBeregnetFelt(felt)) && harVerdi;
    var harGyldigVerdiIOpsjon = gyldigVerdiIOpsjon(felt, verdi, data, visningsdata, kontroll, kodelister);
    return feltSkalDeaktiveresEllerSkjules && !feltSkalBeholdes || !harGyldigVerdiIOpsjon;
};
var feltHarBeholdVerdi = function(felt) {
    var betingelse = Object.keys(felt).find(function(k) {
        return BETINGELSER.includes(k);
    });
    var betingelseMultiple = Object.keys(felt).find(function(k) {
        return BETINGELSER_MULTIPLE.includes(k);
    });
    var beholdVerdi = false;
    if (betingelse) {
        beholdVerdi = felt[betingelse].beholdVerdi;
    }
    if (!beholdVerdi && betingelseMultiple) {
        // Merk at dersom et felt har multiple betingelser, så vil beholdVerdi settes dersom en av betingelsene
        // har denne egenskapen (uavhengig av hvilken betingelse det gjelder)
        beholdVerdi = felt[betingelseMultiple].some(function(delBetingelse) {
            return delBetingelse.beholdVerdi;
        });
    }
    return beholdVerdi;
};
var feltHarAktiverDeaktiverGitt = function(felt) {
    return felt.aktiverGitt || felt.deaktiverGitt;
};
var feltHarReferanseTilAktiverDeaktiverGitt = function(felt, referanse) {
    return (0, _get.default)(felt, "aktiverGitt.referanse", "") === referanse || (0, _get.default)(felt, "deaktiverGitt.referanse", "") === referanse;
};
var skjulFeltMedReferansekobling = function(felt, data, visningsdata, kortdefinisjon) {
    if (kortdefinisjon.forekomstKobling) {
        var _kortdefinisjon_forekomstKobling = kortdefinisjon.forekomstKobling, referanse = _kortdefinisjon_forekomstKobling.referanse, koblingsreferanse = _kortdefinisjon_forekomstKobling.koblingsreferanse;
        var liste = (0, _get.default)(visningsdata, referanse, []);
        return felt.skjulHvisKoblingHarData && liste.some(function(item) {
            return item[koblingsreferanse] === data[koblingsreferanse];
        });
    }
    return false;
};
var finnDefaultVerdi = function(defaultVerdi, data) {
    if (typeof defaultVerdi === "string") {
        return defaultVerdi;
    }
    if (!defaultVerdi) {
        return undefined;
    }
    if (defaultVerdi.betingelse) {
        if (defaultVerdi.betingelse.minstEn && foelgerMinstEnBetingelse(data, defaultVerdi.betingelse.minstEn) || defaultVerdi.betingelse.alle && foelgerAlleBetingelser(data, defaultVerdi.betingelse.alle) || foelgerBetingelse(data, defaultVerdi.betingelse)) {
            return defaultVerdi.defaultVerdi;
        }
    }
    if ((0, _has.default)(defaultVerdi, "ellers")) {
        return finnDefaultVerdi(defaultVerdi.ellers, data);
    }
    return undefined;
};
var skalEkspandereFeltgruppe = function(param, data, visningsdata, kontroll) {
    var visInitielt = param.visInitielt;
    if (visInitielt) {
        if ((0, _isBoolean.default)(visInitielt)) {
            return visInitielt;
        }
        return foelgerBetingelse(data, visInitielt.betingelse, visningsdata, kontroll);
    }
    return false;
};
var erPresentasjonsfelt = function(felt) {
    var _felt_transformer;
    var transformerId = (_felt_transformer = felt.transformer) === null || _felt_transformer === void 0 ? void 0 : _felt_transformer.id;
    if (transformerId) {
        return Object.keys(_flereReferanser).includes(transformerId);
    }
    return false;
};
